import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import BrandMark from '@/components/BrandMark';

type Props = {
  organizationName?: string;
  children: ReactNode;
};

export function SignerLayout({ organizationName, children }: Props) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <header className="bg-white border-b border-border h-14 px-6 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <BrandMark size={28} radius={6} />
          <strong className="text-[16px] text-gray-900">Documentology</strong>
          {organizationName && (
            <span className="text-muted text-[13px] ml-3">{t('sign_page.on_behalf_of', { org: organizationName })}</span>
          )}
        </div>
        <div className="text-[12px] text-muted">{t('sign_page.powered_by')}</div>
      </header>
      <main className="flex-1 px-6 py-8">{children}</main>
      <footer className="border-t border-border bg-white py-4 px-6 text-[11px] text-muted text-center">
        🔒 {t('sign_page.footer_secure')}
      </footer>
    </div>
  );
}
